import { Box, Button, Dropdown, IconButton, Menu, MenuItemProps, Metadata, useGraphqlDelete, useListGraphqlQuery, useNumberFormat, useTranslation, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { TBankInformation } from "@bsm/graphql";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { BANK_LIST_ID } from "../../../container/BankListContainer";
import { DeleteBankDialog } from "../../../components/DeleteBankDialog";

export const BankDetails = (props: Partial<TBankInformation>) => {

    const [
        EDIT,
        DELETE,
    ] = useTranslations(i18n)
    const urlParams = useUrlParamsValueToString()
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | undefined>(undefined);
    const deleteMutation = useGraphqlDelete('bankInformation')
    const { invalidateQuery } = useListGraphqlQuery(BANK_LIST_ID);
    const navigate = useNavigate()
    const t = useTranslation()

    useEffect(() => {
        if (deleteMutation.isSuccess) {
            invalidateQuery()
            navigate(`..?${urlParams}`)
        }
    }, [deleteMutation])

    const [wantToDelete, setWantToDelete] = useState(false);

    const handleClick = (menu: MenuItemProps) => {
        if (menu.ke === "delete") {
            setWantToDelete(true)
        }
    }

    return (
        <div className="flex flex-col gap-4">
            {
                props.isEditable &&
                <div className="flex justify-end gap-2">
                    <Button
                        className="btn-default"
                        startIcon="fa-solid fa-pen"
                        label={EDIT}
                        onClick={() => navigate(`edit?${urlParams}`)}
                    />
                    {
                        props.isDeletable &&
                        <IconButton
                            icon={"fa-ellipsis"}
                            onClick={(e) => setAnchorEl(e.currentTarget)}
                        />
                    }

                    <Dropdown anchorEl={anchorEl} onClose={() => setAnchorEl(undefined)}>
                        <Menu
                            items={[
                                {
                                    label: DELETE,
                                    ke: 'delete'
                                }
                            ]}
                            onClick={handleClick}
                        />
                    </Dropdown>
                </div>
            }

            <Box title={"Informations"}>
                <div className="flex flex-col gap-2 mt-4">

                    <Metadata
                        label={"Bank name"}
                        value={props?.bankName}
                    />

                    <Metadata
                        label={"IBAN"}
                        value={props?.iban}
                    />

                    <Metadata
                        label={"Bank address"}
                        value={props?.bankAdress}
                    />

                    <Metadata
                        label={"Currency"}
                        value={props?.currency}
                    />

                </div>
            </Box>

            <DeleteBankDialog id={props?.id} open={wantToDelete} onClose={() => setWantToDelete(false)}/>
        </div >
    )

}

const i18n = [
    'std_edit',
    'std_delete',
]
